import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetPessoaExportarExcel() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getPessoaExportarExcel = useCallback(
        async (page: number, queryBusca: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || queryBusca?.length > 0 ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Pessoa/excel${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: true,
                responseType: 'blob',
                timeout: 180000,
                headers: {
                    "Content-Type": "application/vnd.ms-excel",
                    "Content-Disposition": "attachment; filename=pessoas.xls; filename*=UTF-8''pessoas.xls"
                },
            })
        }
        , [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getPessoaExportarExcel,
    };
}
